import formModel from './formModel';

const {
    formField: {
        names,
        lastName,
        codArea,
        phone,
        email,
        dni,
        cuit,
        address,
        sex,
        codigosLocalidad,
        numProd
    }
} = formModel;


export default {
    [names.name]: '',
    [lastName.name]: '',
    [email.name]: '',
    [codArea.name]: '',
    [phone.name]: '',
    [dni.name]: '',
    [cuit.name]: '',
    [address.name]: '',
    [sex.name]: '0',
    [codigosLocalidad.name]: '',
    [numProd.name]: '221209'
};
